export * from './ngx-select-dropdown.component';
//# sourceMappingURL=index.js.map